var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.47427 17.6624H4.66962V6.93724",
    stroke: "url(#paint0_linear_15_1245)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.3304 6.93724V17.6624H16.5258",
    stroke: "url(#paint1_linear_15_1245)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_1245",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.25 21.2501V2.75006H2.74994V21.2501H21.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_1245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.59271 8.17096L12 2.58594L21.4073 8.17096",
    stroke: "url(#paint2_linear_15_1245)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.5257 21.4142H7.47422L7.47418 9.47208L11.9999 6.89945L16.5257 9.47208V21.4142Z",
    stroke: "url(#paint3_linear_15_1245)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.2187 14.1613C13.1915 14.1322 12.4689 13.531 11.5847 13.7974C10.7728 14.0419 10.6592 14.9781 11.2466 15.361C11.2466 15.361 11.823 15.6181 12.4623 15.854C14.001 16.4216 13.3382 17.9103 12.0994 17.9103C11.479 17.9103 10.9584 17.6387 10.6432 17.2909",
    stroke: "url(#paint4_linear_15_1245)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.007 13.7307V13.1447",
    stroke: "url(#paint5_linear_15_1245)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.007 18.4963V17.9083",
    stroke: "url(#paint6_linear_15_1245)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.4141 10.3008H12.5859",
    stroke: "url(#paint7_linear_15_1245)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_1245",
    x1: 7.47427,
    y1: 17.6624,
    x2: 4.10295,
    y2: 17.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ADDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_1245",
    x1: 19.3304,
    y1: 17.6624,
    x2: 15.9591,
    y2: 17.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ADDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15_1245",
    x1: 21.4073,
    y1: 8.17096,
    x2: 5.59446,
    y2: -2.24597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ADDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15_1245",
    x1: 16.5257,
    y1: 21.4142,
    x2: 5.77676,
    y2: 20.1034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ADDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15_1245",
    x1: 13.3568,
    y1: 17.9103,
    x2: 10.1383,
    y2: 17.5019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ADDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15_1245",
    x1: 13.007,
    y1: 13.7307,
    x2: 11.9226,
    y2: 13.3687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ADDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15_1245",
    x1: 13.007,
    y1: 18.4963,
    x2: 11.9219,
    y2: 18.1354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ADDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15_1245",
    x1: 12.5859,
    y1: 10.3008,
    x2: 11.2441,
    y2: 9.99334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ADDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.8d4d8ba427de4132a57c94d8114a2d57.svg";
export { ForwardRef as ReactComponent };